import { FormattedMessage, useIntl } from 'react-intl';
import { IconButton } from '@mui/material';
import { DeleteOutlineIcon } from 'components/Icons';
import ReactHookFormField from 'components/ReactHookFormField';
import useRequiredTrainingsField from 'hooks/pdp/form/useRequiredTrainingsField';
import { useFormContext } from 'react-hook-form';
import { PDPFormValues } from 'types/pdp';
import { pdpTexts } from 'i18n';
import { usePagePermissions } from 'hooks';
import useUserRoles from 'hooks/users/useUserRoles';
import messages from '../messages';
import { FieldsRow } from './EditPDP.styled';
import {
  RequiredTrainingCard,
  TrainingNameField,
} from './RequiredTrainingForm.styled';

interface RequiredTrainingFormProps {
  trainingIndex: number;
  isEdit: boolean;
}

export default function RequiredTrainingForm({
  trainingIndex,
  isEdit,
}: RequiredTrainingFormProps) {
  const { formatMessage } = useIntl();
  const { removeRequiredTraining } = useRequiredTrainingsField(
    useFormContext<PDPFormValues>(),
  );
  const { hasFullAccess } = usePagePermissions();
  const { isPeoplePartner } = useUserRoles();

  const canEditStatus = isEdit
    ? hasFullAccess || Boolean(isPeoplePartner)
    : false;

  const trainingStatusOptions = [
    { id: 'requested', name: formatMessage(pdpTexts.requested) },
    {
      id: 'invited_but_not_attended',
      name: formatMessage(pdpTexts.invitedButNotAttended),
    },
    { id: 'approved', name: formatMessage(pdpTexts.approved) },
    { id: 'passed', name: formatMessage(pdpTexts.passed) },
  ];

  return (
    <RequiredTrainingCard>
      <FieldsRow>
        <TrainingNameField>
          <ReactHookFormField
            name={`requiredTrainings.${trainingIndex}.name`}
            type="text"
            label={<FormattedMessage {...pdpTexts.trainingName} />}
            placeholder={formatMessage(messages.enterTrainingName)}
            rules={{ required: 'Training name is required' }}
          />
        </TrainingNameField>
        <ReactHookFormField
          name={`requiredTrainings.${trainingIndex}.status`}
          type="select"
          label={<FormattedMessage {...pdpTexts.trainingStatus} />}
          options={trainingStatusOptions}
          fieldProps={{
            size: 'medium',
          }}
          disabled={!canEditStatus}
        />
        <IconButton
          size="small"
          color="primary"
          onClick={() => removeRequiredTraining(trainingIndex)}
          aria-label={formatMessage(messages.deleteTraining)}
        >
          <DeleteOutlineIcon />
        </IconButton>
      </FieldsRow>
    </RequiredTrainingCard>
  );
}
